import React, {FC} from 'react';
import messages from '../messages';
import Filters from './filters';
import TagsRow from './tags-row';
import Icon from '@ailibs/feather-react-ts/dist/Icon';
import AppBarActions from 'components/VerticalLayout/app-bar-actions';
import {FilterMap} from 'features/table/slice/types';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {CardBody, Col, Row} from 'reactstrap';
import Can from 'features/hylian-shield/can';

interface FilterProps {
  filters: FilterMap;
  onChangeFilters: (key: string, value: any) => void;
  onClearFilters?: () => void;
}

const QuatationControls: FC<FilterProps> = props => {
  const {t} = useTranslation();

  const {filters, onChangeFilters, onClearFilters} = props;

  return (
    <Row>
      <Col>
        <CardBody>
          <TagsRow />

          <Row className="mb-3">
            <AppBarActions>
              <Can subject={['dcv', 'dcz']} action="create-and-edit">
                <Link
                  to="/dashboard/quotations/create"
                  className="btn btn-important"
                >
                  <Icon name="plus" className="me-1" size={15} />
                  {t(...messages.addQuotation())}
                </Link>
              </Can>
            </AppBarActions>
          </Row>
          <Filters
            filters={filters}
            onChangeFilters={onChangeFilters}
            onClearFilters={onClearFilters}
          />
        </CardBody>
      </Col>
    </Row>
  );
};

export default QuatationControls;
